<template>
  <div>
    <div>
      <v-card class="card_container">
        <v-card-title
          style="background-color: #82a1d0"
          background-color="primary"
          class="d-flex justify-space-between"
        >
          <v-text-field
            dense
            solo
            v-model="search"
            append-icon="mdi-magnify"
            :label="$tc('commons.search')"
            single-line
            hide-details
            class="search"
          />
          <v-dialog
            v-model="btnConfigColumns.menu"
            max-width="400px"
            @keydown.esc="toggleColumnMenu"
            offset-x
          >
            <template v-slot:activator="{ on, attrs }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-col cols="auto" class="my-n4 pr-0">
                    <v-row class="justify-start border ma-0">
                      <v-btn
                        color="white"
                        dark
                        icon
                        @click="toggleColumnMenu"
                        v-bind="attrs"
                        v-on="on"
                        class="btn-table ma-1"
                        small
                      >
                        <v-icon size="20">{{ btnConfigColumns.icon }}</v-icon>
                      </v-btn>
                    </v-row>
                  </v-col>
                </template>
                <span>{{ btnConfigColumns.tooltip }}</span>
              </v-tooltip>
            </template>

            <v-card>
              <v-text-field
                v-model="columnFilter"
                placeholder="Buscar columnas"
                outlined
                dense
                hide-details
                class="pa-2 pb-0 ma-0"
              ></v-text-field>
              <div
                style="
                  min-width: 250px;
                  max-height: 250px;
                  overflow-y: scroll;
                  scrollbar-width: unset;
                "
                class="pa-2 pb-0 ma-0"
                hide-details
              >
                <div
                  v-if="filteredColumns?.length === 0"
                  class="text-center px-2 pb-2"
                >
                  <span>No hay resultados que coincidan con la búsqueda</span>
                </div>
                <div v-else>
                  <div
                    v-for="column in filteredColumns"
                    :key="column.field"
                    hide-details
                  >
                    <v-checkbox
                      v-model="column.visible"
                      :label="column.text"
                      hide-details
                      class="my-auto mb-2"
                    ></v-checkbox>
                  </div>
                </div>
              </div>
              <v-card-actions class="d-flex justify-space-between">
                <v-btn class="bt-exit" @click="toggleColumnMenu">
                  <v-icon>fas fa-times</v-icon>
                </v-btn>

                <v-btn
                  color="bt-acept"
                  @click="
                    headersUpdated();
                    toggleColumnMenu();
                  "
                >
                  <v-icon>fas fa-save</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card-title>
        <v-divider></v-divider>
        <v-data-table
          :search="search"
          :hide-default-footer="true"
          disable-pagination
          :items="items"
          style="min-width: 100%"
          @click:row="goToItem"
          :height="calculateMaxHeight"
          fixed-header
          :headers="visibleHeaders"
          v-sortable-columns="saveColumnOrder"
          :key="tableKey"
        >
          <template v-slot:[`item.actions`]="{ item }">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <div class="center">
                    <v-icon small color="primary" @click="openDialog(item)">
                      {{ showAction.icon }}</v-icon
                    >
                  </div>
                </span>
              </template>
              <v-list class="v-list__" :key="formkey">
                <v-list-item-group v-model="localSelectedItem" color="primary">
                  <v-list-item
                    v-for="(action, index) in actions"
                    :key="index"
                    @click="switchActions(index, item)"
                    style="cursor: pointer"
                    color="primary"
                    class="itemhover"
                    :disabled="action.disabled"
                  >
                    <v-list-item-icon>
                      <v-icon small class="hovericon">{{ action.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>{{ action.text }} </v-list-item-title>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-menu>
          </template>
          <template v-slot:[`item.state`]="{ item }">
            <div class="d-flex justify-center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    <v-icon :color="stateColor(item)">
                      {{ stateIcon(item.state) }}
                    </v-icon>
                  </span>
                </template>
                <span>{{ stateTooltip(item.state) }}</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </div>
</template>

<script>
import Sortable from "sortablejs";

export default {
  props: {
    headers: Array,
    items: Array,
    title: String,
    goToItem: {
      type: Function,
      default: () => {},
    },
    openDialog: Function,
    showAction: {
      type: Object,
    },
    actions: {
      type: Array,
    },

    switchActions: {
      type: Function,
    },
    formkey: {
      type: Number,
    },
    selectedItem: {
      type: Object,
    },
    saveConfigColums: Function,
  },

  data() {
    return {
      search: "",
      btnConfigColumns: {
        menu: false,
        icon: "mdi-cog",
        tooltip: "Columnas",
      },
      columnFilter: "",
      tableKey: 0,
      localHeaders: this.headers?.map((header) => ({ ...header })),
    };
  },

  computed: {
    localSelectedItem: {
      get() {
        return this.selectedItem;
      },
      set(value) {
        this.$emit("update:selectedItem", value);
      },
    },

    calculateMaxHeight() {
      switch (true) {
        case this.items?.length >= 10:
          return "60vh";
      }
    },
    filteredColumns() {
      const filterText = this.columnFilter.toLowerCase();
      return this.localHeaders?.filter((column) => {
        return column.text?.toLowerCase().includes(filterText);
      });
    },
    visibleHeaders() {
      return this.localHeaders?.filter((column) => column.visible);
    },
  },
  watch: {
    headers: {
      handler(newHeaders) {
        this.localHeaders = newHeaders.map((header) => ({ ...header }));
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    stateColor(item) {
      return item.state === "Abierta" ? "green" : "amber darken-1";
    },
    stateIcon(state) {
      return state === "Abierta" ? "mdi-lock-open-variant" : "mdi-lock";
    },
    stateTooltip(state) {
      return state === "Abierta" ? "Abierta" : "Cerrada";
    },
    headersUpdated() {
      this.$emit("headersUpdated", this.localHeaders);
    },
    toggleColumnMenu() {
      this.btnConfigColumns.menu = !this.btnConfigColumns.menu;
    },
    saveColumnOrder(newIndex, oldIndex) {
      const visibleHeaders = this.localHeaders.filter(
        (header) => header.visible
      );
      const movedColumn = visibleHeaders.splice(oldIndex, 1)[0];
      visibleHeaders.splice(newIndex, 0, movedColumn);
      const newHeaders = [];
      let visibleIndex = 0;
      for (const header of this.localHeaders) {
        if (header.visible) {
          newHeaders.push(visibleHeaders[visibleIndex]);
          visibleIndex++;
        } else {
          newHeaders.push(header);
        }
      }
      this.localHeaders = newHeaders.map((header) => ({ ...header }));
      this.tableKey++;
      this.$forceUpdate();
    },
  },
  directives: {
    sortableColumns: {
      inserted(el, binding) {
        const table = el.querySelector("table");
        const headerRow = table.querySelector("thead tr");
        const sortableHeaders = Array.from(headerRow.children);
        const options = {
          animation: 150,
          ghostClass: "sortable-ghost",
          onEnd: function (event) {
            const newIndex = event.newIndex;
            const oldIndex = event.oldIndex;
            binding.value(newIndex, oldIndex);
          },
        };
        Sortable.create(headerRow, options);
      },
    },
  },
};
</script>

<style scoped>
.border {
  background-color: #1f324a2f;
  border-color: #a5b9d7;
  border-width: 5px;
  border-style: solid;
  border-radius: 25px;
}
.btn-table {
  background-color: #82a1d0;
}
.card_container {
  max-width: 100%;
}
.dataTable {
  overflow-y: scroll !important;
  scrollbar-width: unset;
}
.search {
  max-width: 500px;
}
.bt-acept {
  border-radius: 20px !important;
  background-color: #39537a !important;
}
.btn-add {
  max-width: 10px !important;
  background-color: #82acec !important;
}
.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}
.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}
::v-deep .v-data-table--fixed-header > .v-data-table__wrapper {
  overflow-y: scroll;
  scrollbar-width: unset;
}
</style>
